import type { LanguageCode, LanguageInfo } from '../../types/language';

export const SET_LANGUAGES = 'SET_LANGUAGES' as const;
export const SET_CURRENT_LANGUAGE = 'SET_CURRENT_LANGUAGE' as const;
export const SET_TOUR_LANGUAGE = 'SET_TOUR_LANGUAGE' as const;

interface LanguagePayloadItem {
    languages_code: LanguageInfo;
}

export const setLanguages = (languages: LanguagePayloadItem[]) => ({
    type: SET_LANGUAGES,
    payload: languages
});

export const setCurrentLanguage = (languageCode: LanguageCode) => ({
    type: SET_CURRENT_LANGUAGE,
    payload: languageCode
});

export const setTourLanguage = (languageCode: LanguageCode) => ({
    type: SET_TOUR_LANGUAGE,
    payload: languageCode
});

export type LanguageAction =
    | ReturnType<typeof setLanguages>
    | ReturnType<typeof setCurrentLanguage>
    | ReturnType<typeof setTourLanguage>;
